import ClassPage from "../../vue/components/pages/ClassPage.vue";
import ClientPage from "../../vue/components/pages/ClientPage.vue";
import CommunityPage from "../../vue/components/pages/CommunityPage.vue";
import CourseListPage from "../../vue/components/pages/CourseListPage.vue";
import CoursePage from "../../vue/components/pages/CoursePage.vue";
import DashboardPage from "../../vue/components/pages/DashboardPage.vue";
import PlanPage from "../../vue/components/pages/PlanPage.vue";
import ProfilePage from "../../vue/components/pages/ProfilePage.vue";
import ProjectListPage from "../../vue/components/pages/ProjectListPage.vue";
import ProjectPage from "../../vue/components/pages/ProjectPage.vue";
import ProposalListPage from "../../vue/components/pages/ProposalListPage.vue";
import VideoListPage from "../../vue/components/pages/VideoListPage.vue";
import VideoPage from "../../vue/components/pages/VideoPage.vue";

import LoginErrorPage from "../../vue/components/pages/LoginErrorPage.vue";
import LoginSuccessPage from "../../vue/components/pages/LoginSuccessPage.vue";
import NotFoundPage from "../../vue/components/pages/NotFoundPage.vue";
import SignupPage from "../../vue/components/pages/SignupPage.vue";
import SubscribePage from "../../vue/components/pages/SubscribePage.vue";
import ContactPage from "../../vue/components/pages/ContactPage.vue";

const routes = [
    { path: ``, component: DashboardPage },
    { path: `/perfil`, component: ProfilePage },
    { path: `/plano`, component: PlanPage },
    { path: `/propostas`, component: ProposalListPage },
    { path: `/projetos`, component: ProjectListPage },
    { path: `/projeto/:projectId`, component: ProjectPage },
    { path: `/cliente/:clientId`, component: ClientPage },
    { path: `/aulas-e-mentorias`, component: VideoListPage },
    { path: `/aula/:id`, component: VideoPage },
    { path: `/mentoria/:id`, component: VideoPage },
    { path: `/cursos`, component: CourseListPage },
    { path: `/curso/intro-av`, component: CoursePage },
    { path: `/curso/:catchAll(.*)`, component: CoursePage },
    { path: `/curso/:courseId/:classId`, component: ClassPage },
    // { path: `/ferramentas`, component: ToolListPage },
    { path: `/comunidade`, component: CommunityPage },
    { path: `/contato`, component: ContactPage },
    { path: `/cadastro`, component: SignupPage },
    { path: `/login-feito`, component: LoginSuccessPage },
    { path: `/erro-login`, component: LoginErrorPage },
    { path: `/assinar`, component: SubscribePage },
    { path: `/assinar/:utm`, component: SubscribePage },
    { path: "/:catchAll(.*)", component: NotFoundPage }
];

export default routes;